export type IGetFieldProperties = (
  fieldSelector: string,
  fieldSuffix?: string
) => IDCA.IFieldsObject | null;

export function getFieldProperties(
  fieldSelector: string,
  fieldSuffix = ''
): IDCA.IFieldsObject | null {
  const allFields = (window as any)[`fields${fieldSuffix}`];

  if (allFields) {
    for (const field of allFields) {
      try {
        if (
          String(field.id) === String(fieldSelector) ||
          field.identifier === String(fieldSelector)
        ) {
          return field;
        }
      } catch (e) {
        if (window.debug) {
          console.warn(`ERROR : allFields = ${e}`);
        }
      }
    }
  }
  return null;
}
